module.exports = __webpack_public_path__ + "static/media/iconForecast.58eb6a90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconForecast.svg
// module id = 210
// module chunks = 0